"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var Icon_1 = require("./Icon");
Object.defineProperty(exports, "Icon", { enumerable: true, get: function () { return Icon_1.Icon; } });
__exportStar(require("./Assets/AccountIcon"), exports);
__exportStar(require("./Assets/AgentBookingIcon"), exports);
__exportStar(require("./Assets/AlertIcon"), exports);
__exportStar(require("./Assets/AlertOutlineIcon"), exports);
__exportStar(require("./Assets/AlertTriangleIcon"), exports);
__exportStar(require("./Assets/ApplicationCompleteIcon"), exports);
__exportStar(require("./Assets/ApplicationIcon"), exports);
__exportStar(require("./Assets/ArrowDownIcon"), exports);
__exportStar(require("./Assets/ArrowDownrightIcon"), exports);
__exportStar(require("./Assets/ArrowLeftIcon"), exports);
__exportStar(require("./Assets/ArrowRightIcon"), exports);
__exportStar(require("./Assets/ArrowUpIcon"), exports);
__exportStar(require("./Assets/AsteriskIcon"), exports);
__exportStar(require("./Assets/AttendeesIcon"), exports);
__exportStar(require("./Assets/BarcodeIcon"), exports);
__exportStar(require("./Assets/BookingIcon"), exports);
__exportStar(require("./Assets/BuildingIcon"), exports);
__exportStar(require("./Assets/BulletIcon"), exports);
__exportStar(require("./Assets/CalendarIcon"), exports);
__exportStar(require("./Assets/CameraIcon"), exports);
__exportStar(require("./Assets/CancelledIcon"), exports);
__exportStar(require("./Assets/CaretDownIcon"), exports);
__exportStar(require("./Assets/CaretLeftIcon"), exports);
__exportStar(require("./Assets/CaretRightIcon"), exports);
__exportStar(require("./Assets/CaretUpIcon"), exports);
__exportStar(require("./Assets/ChartGanttIcon"), exports);
__exportStar(require("./Assets/ChartReportIcon"), exports);
__exportStar(require("./Assets/CheckboxIcon"), exports);
__exportStar(require("./Assets/CheckboxUnselectedIcon"), exports);
__exportStar(require("./Assets/CheckInIcon"), exports);
__exportStar(require("./Assets/CheckOutIcon"), exports);
__exportStar(require("./Assets/ChevronDownIcon"), exports);
__exportStar(require("./Assets/ChevronDownSmallIcon"), exports);
__exportStar(require("./Assets/ChevronLeftIcon"), exports);
__exportStar(require("./Assets/ChevronLeftSmallIcon"), exports);
__exportStar(require("./Assets/ChevronRightIcon"), exports);
__exportStar(require("./Assets/ChevronRightSmallIcon"), exports);
__exportStar(require("./Assets/ChevronRightThinIcon"), exports);
__exportStar(require("./Assets/ChevronUpIcon"), exports);
__exportStar(require("./Assets/ChevronUpSmallIcon"), exports);
__exportStar(require("./Assets/ChevronUpThinIcon"), exports);
__exportStar(require("./Assets/ClockIcon"), exports);
__exportStar(require("./Assets/CloseCircleIcon"), exports);
__exportStar(require("./Assets/CloseThickIcon"), exports);
__exportStar(require("./Assets/CloseThinIcon"), exports);
__exportStar(require("./Assets/CogIcon"), exports);
__exportStar(require("./Assets/ColumnIcon"), exports);
__exportStar(require("./Assets/ConnectIcon"), exports);
__exportStar(require("./Assets/DesignerIcon"), exports);
__exportStar(require("./Assets/DragIcon"), exports);
__exportStar(require("./Assets/EditIcon"), exports);
__exportStar(require("./Assets/EllipsesHorizontalIcon"), exports);
__exportStar(require("./Assets/EllipsesVerticalIcon"), exports);
__exportStar(require("./Assets/ExportIcon"), exports);
__exportStar(require("./Assets/FieldTypeBooleanIcon"), exports);
__exportStar(require("./Assets/FieldTypeDateIcon"), exports);
__exportStar(require("./Assets/FieldTypeIntIcon"), exports);
__exportStar(require("./Assets/FieldTypeKeyIcon"), exports);
__exportStar(require("./Assets/FieldTypeStringIcon"), exports);
__exportStar(require("./Assets/FileIcon"), exports);
__exportStar(require("./Assets/FilterActiveIcon"), exports);
__exportStar(require("./Assets/FiltersIcon"), exports);
__exportStar(require("./Assets/FirstIcon"), exports);
__exportStar(require("./Assets/FlagIcon"), exports);
__exportStar(require("./Assets/FolderIcon"), exports);
__exportStar(require("./Assets/FolderOpenIcon"), exports);
__exportStar(require("./Assets/FolderOutlineIcon"), exports);
__exportStar(require("./Assets/FolderSharedIcon"), exports);
__exportStar(require("./Assets/FolderStarredIcon"), exports);
__exportStar(require("./Assets/FoodIcon"), exports);
__exportStar(require("./Assets/FunctionIcon"), exports);
__exportStar(require("./Assets/GroupsIcon"), exports);
__exportStar(require("./Assets/HeadsetIcon"), exports);
__exportStar(require("./Assets/HeartIcon"), exports);
__exportStar(require("./Assets/HelpIcon"), exports);
__exportStar(require("./Assets/HideIcon"), exports);
__exportStar(require("./Assets/HomeIcon"), exports);
__exportStar(require("./Assets/ImagePlaceholderIcon"), exports);
__exportStar(require("./Assets/ImportIcon"), exports);
__exportStar(require("./Assets/InspectionIcon"), exports);
__exportStar(require("./Assets/InteractionIcon"), exports);
__exportStar(require("./Assets/InvoicingIcon"), exports);
__exportStar(require("./Assets/KeyIcon"), exports);
__exportStar(require("./Assets/LastIcon"), exports);
__exportStar(require("./Assets/LinkIcon"), exports);
__exportStar(require("./Assets/ListIcon"), exports);
__exportStar(require("./Assets/LockIcon"), exports);
__exportStar(require("./Assets/MailIcon"), exports);
__exportStar(require("./Assets/MapMarkerIcon"), exports);
__exportStar(require("./Assets/ModuleAdminIcon"), exports);
__exportStar(require("./Assets/ModuleCampusLifeIcon"), exports);
__exportStar(require("./Assets/ModuleConductIcon"), exports);
__exportStar(require("./Assets/ModuleConferenceIcon"), exports);
__exportStar(require("./Assets/ModuleCustomIcon"), exports);
__exportStar(require("./Assets/ModuleDashboardIcon"), exports);
__exportStar(require("./Assets/ModuleEntriesIcon"), exports);
__exportStar(require("./Assets/ModuleFrontDeskIcon"), exports);
__exportStar(require("./Assets/ModuleKeysIcon"), exports);
__exportStar(require("./Assets/ModuleMarketplaceIcon"), exports);
__exportStar(require("./Assets/ModulePortalIcon"), exports);
__exportStar(require("./Assets/ModuleReportsIcon"), exports);
__exportStar(require("./Assets/ModuleRoomInspectionsIcon"), exports);
__exportStar(require("./Assets/ModuleRoomMatchIcon"), exports);
__exportStar(require("./Assets/ModuleRoomsIcon"), exports);
__exportStar(require("./Assets/ModuleTrustAccountIcon"), exports);
__exportStar(require("./Assets/MouseHandDragIcon"), exports);
__exportStar(require("./Assets/MouseHandIcon"), exports);
__exportStar(require("./Assets/MousePointerIcon"), exports);
__exportStar(require("./Assets/NavIcon"), exports);
__exportStar(require("./Assets/NoteIcon"), exports);
__exportStar(require("./Assets/NoteAddIcon"), exports);
__exportStar(require("./Assets/OpenLinkIcon"), exports);
__exportStar(require("./Assets/PageIcon"), exports);
__exportStar(require("./Assets/PageLandscapeIcon"), exports);
__exportStar(require("./Assets/PagePortraitIcon"), exports);
__exportStar(require("./Assets/PaperClip"), exports);
__exportStar(require("./Assets/ParameterActiveIcon"), exports);
__exportStar(require("./Assets/ParameterIcon"), exports);
__exportStar(require("./Assets/ParcelIcon"), exports);
__exportStar(require("./Assets/PawIcon"), exports);
__exportStar(require("./Assets/PhoneIcon"), exports);
__exportStar(require("./Assets/PictureIcon"), exports);
__exportStar(require("./Assets/PlusIcon"), exports);
__exportStar(require("./Assets/PortalIcon"), exports);
__exportStar(require("./Assets/PreviewIcon"), exports);
__exportStar(require("./Assets/PrintIcon"), exports);
__exportStar(require("./Assets/RefreshIcon"), exports);
__exportStar(require("./Assets/ReportIcon"), exports);
__exportStar(require("./Assets/RepositionIcon"), exports);
__exportStar(require("./Assets/ResourcesIcon"), exports);
__exportStar(require("./Assets/SaveIcon"), exports);
__exportStar(require("./Assets/SearchIcon"), exports);
__exportStar(require("./Assets/SearchStopIcon"), exports);
__exportStar(require("./Assets/ShareIcon"), exports);
__exportStar(require("./Assets/ShieldNegativeIcon"), exports);
__exportStar(require("./Assets/ShieldPositiveIcon"), exports);
__exportStar(require("./Assets/SortIcon"), exports);
__exportStar(require("./Assets/SourceIcon"), exports);
__exportStar(require("./Assets/SrIconFullIcon"), exports);
__exportStar(require("./Assets/SrIconSimpleIcon"), exports);
__exportStar(require("./Assets/StarIcon"), exports);
__exportStar(require("./Assets/StarOutlineIcon"), exports);
__exportStar(require("./Assets/SubReportIcon"), exports);
__exportStar(require("./Assets/TasksIcon"), exports);
__exportStar(require("./Assets/TemporarySpaceIcon"), exports);
__exportStar(require("./Assets/TickCircleIcon"), exports);
__exportStar(require("./Assets/TickIcon"), exports);
__exportStar(require("./Assets/TickRoundedIcon"), exports);
__exportStar(require("./Assets/ToolIcon"), exports);
__exportStar(require("./Assets/TrashIcon"), exports);
__exportStar(require("./Assets/UserIcon"), exports);
__exportStar(require("./Assets/UsersIcon"), exports);
__exportStar(require("./Assets/VariableIcon"), exports);
__exportStar(require("./Assets/ViewIcon"), exports);
__exportStar(require("./Assets/ZoomIcon"), exports);
